import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const SourceDocumentsPageContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: '100%',
  alignItems: "center",
  backgroundColor: theme.palette.jigsaw.white,
}));
 
export const Header = styled(Box)(({ theme }) => ({
   fontFamily: 'Roboto',
   fontWeight: 700,
   fontSize: '42px',
   lineHeight: '110%',
   letterSpacing: '0%',
   textAlign: 'center',
   color: theme.palette.jigsaw.header,
   padding: "30px",
}));
 
export const SubHeader = styled(Box)(({ theme }) => ({
  fontFamily: 'Roboto',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: '140%',
  letterSpacing: '0%',
  textAlign: 'center',
  color: theme.palette.jigsaw.header,
  padding: "5px",
  marginBottom: "35px",
}));
  
export const ImportButton = styled(Box)(({ theme }) => ({
  width: "400px",
  height: "55px",
  padding: "16px 12px",
  borderRadius: "5px",
  borderWidth: "2px",
  borderStyle: "solid",
  borderColor: theme.palette.jigsaw.blue,
  backgroundColor: theme.palette.jigsaw.blue,
  color: "#FFFFFF",
  fontSize: "16px",
  fontWeight: "bold",
  textAlign: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "all 0.3s ease",
  marginTop: "35px",
  
  "&:hover": {
    backgroundColor: theme.palette.jigsaw.darkBlue,
  },
}));

export const ButtonContainer = styled(Box)({
  display: "flex",
  gap: "21px",
  marginTop: "35px",
});

export const GenerateButton = styled(Box)(({ theme }) => ({
  width: "157px",
  height: "48px",
  padding: "16px 12px",
  borderRadius: "5px",
  borderWidth: "2px",
  borderStyle: "solid",
  borderColor: theme.palette.jigsaw.blue,
  backgroundColor: theme.palette.jigsaw.blue,
  color: "#FFFFFF",
  fontSize: "16px",
  fontWeight: "bold",
  textAlign: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "all 0.3s ease",

  "&:hover": {
    backgroundColor: theme.palette.jigsaw.darkBlue,
  },
}));

export const ReselectButton = styled(Box)(({ theme }) => ({
  width: "157px",
  height: "48px",
  padding: "16px 12px",
  borderRadius: "5px",
  borderWidth: "2px",
  borderStyle: "solid",
  borderColor: theme.palette.jigsaw.blue,
  backgroundColor: theme.palette.jigsaw.white,
  color: theme.palette.jigsaw.blue,
  fontSize: "16px",
  fontWeight: "bold",
  textAlign: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "all 0.3s ease",

  "&:hover": {
    backgroundColor: theme.palette.jigsaw.darkBlue,
  },
}));

export const DropZoneContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  maxWidth: "1000px",
});

export const DropZonesGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "20px",
  width: "100%",
  marginBottom: "30px",
  "& > *:nth-child(5)": {
    gridColumn: "1 / span 2",
    justifySelf: "center",
    width: "calc(50% - 10px)",
  },
});

export const DropZone = styled(Box)(({ theme, hasFile }) => ({
  width: "100%",
  minHeight: "180px",
  padding: "20px",
  borderRadius: "8px",
  borderWidth: "2px",
  borderStyle: "dashed",
  borderColor: hasFile ? theme.palette.jigsaw.blue : theme.palette.jigsaw.grey,
  backgroundColor: hasFile ? theme.palette.jigsaw.lightBlue || "#f0f8ff" : theme.palette.jigsaw.white,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  cursor: "pointer",
  transition: "all 0.3s ease",
  
  "&:hover": {
    borderColor: theme.palette.jigsaw.blue,
    backgroundColor: theme.palette.jigsaw.lightBlue || "#f8f9fa",
  },
}));

export const DropZoneLabel = styled(Box)(({ theme }) => ({
  fontFamily: 'Roboto',
  fontWeight: 600,
  fontSize: '16px',
  color: theme.palette.jigsaw.header,
  marginBottom: "15px",
}));

export const DropZoneContent = styled(Box)(({ theme }) => ({
  fontFamily: 'Roboto',
  fontWeight: 400,
  fontSize: '14px',
  color: theme.palette.jigsaw.text || "#666",
  lineHeight: "1.5",
  
  "& > div": {
    marginBottom: "5px",
  },
}));

export const FileInfo = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "8px",
  fontFamily: 'Roboto',
  fontSize: '14px',
  color: theme.palette.jigsaw.header,
  
  "& button": {
    background: "none",
    border: "1px solid " + theme.palette.jigsaw.blue,
    color: theme.palette.jigsaw.blue,
    padding: "4px 8px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    
    "&:hover": {
      backgroundColor: theme.palette.jigsaw.blue,
      color: "white",
    },
  },
}));